import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PulseIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="pulse" ref={ref} {...props}>
      <path d="M15,20.25a.74.74,0,0,1-.69-.47L9,6.52,6.69,12.28a.75.75,0,0,1-.69.47H3a.75.75,0,0,1,0-1.5h2.5l2.81-7a.78.78,0,0,1,1.39,0L15,17.48l2.31-5.76a.75.75,0,0,1,.69-.47h3a.75.75,0,1,1,0,1.5h-2.5l-2.81,7A.74.74,0,0,1,15,20.25Z" />
    </Icon>
  ),
) as IconWithRender;

PulseIcon.displayName = 'PulseIcon';
PulseIcon.renderIcon = (props) => <PulseIcon {...props} />;
export default PulseIcon;
